export const COLLABORATOR_TYPES = Object.freeze({
  COLLABORATOR: 'collaborator',
  HOLDING: 'holding',
})